// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const siret: CountryValidator<"FR"> = createValidator(
  "fr.siret",
  77,
);

export default siret;
export const compact = siret.compact;
export const format = siret.format;
export const validate = siret.validate;
export const generate = (): string =>
  siret.generate?.() ??
  (() => {
    throw new Error(
      "Validator fr.siret cannot generate values",
    );
  })();
